import React, { useEffect, useRef, useState } from "react";
import CircleBg from "../common/CircularBgProps";
import { IsDarkModeProp, SkillDetailProps } from "../common/types";
import SkillsetBlack from "../../assets/images/SkillsBlack.png";
import SkillsetWhite from "../../assets/images/SkillsWhite.png";
import "../../App.css";

import jsIcon from "../../assets/images/js.png";
import tsIcon from "../../assets/images/TS.png";
import nodejsIcon from "../../assets/images/Nodejs.png";
import figmaIcon from "../../assets/images/figma.png";
import boostrapIcon from "../../assets/images/Boostrap.png";
import htmlDarkIcon from "../../assets/images/HTMLDark.png";
import htmlLightIcon from "../../assets/images/HTMLWhite.png";
import cssDarkIcon from "../../assets/images/cssDark.png";
import cssLightIcon from "../../assets/images/cssWhite.png";
import flutterIcon from "../../assets/images/flutter.png";
import reactIcon from "../../assets/images/react.png";
import jqueryDarkIcon from "../../assets/images/JqueryDark.png";
import jqueryLightIcon from "../../assets/images/JqueryWhite.png";
import mongodbDarkIcon from "../../assets/images/mongodbDark.png";
import mongodbLightIcon from "../../assets/images/mongodbLight.png";
import expressIcon from "../../assets/images/expressjs.png";
import sassIcon from "../../assets/images/Sass.png";
import gitIcon from "../../assets/images/git.png";
import mysqlIcon from "../../assets/images/mysql.png";
import { styled } from "styled-components";
import useMediaQuery from "../../hooks/useMediaQuerryHook";
import { Name } from "../common/gradientProps";
import GsapMagnetic from "./GsapMagnetic";
import Circlebtn from "./Circlebtn";
import { Images } from "../../config/ImagesExports";

// List of skills with corresponding icons
const skills = [
  { name: "Boostrap", icon: boostrapIcon, strength: 87 },
  { name: "Scss", icon: sassIcon, strength: 85 },
  { name: "CSS", iconDark: cssDarkIcon, iconLight: cssLightIcon, strength: 91 },
  {
    name: "HTML",
    iconDark: htmlDarkIcon,
    iconLight: htmlLightIcon,
    strength: 93,
  },
  { name: "Figma", icon: figmaIcon, strength: 95 },
  { name: "Version Control System", icon: gitIcon, strength: 80 },
    {
    name: "MongoDB",
    iconDark: mongodbLightIcon,
    iconLight: mongodbDarkIcon,
    strength: 88,
  }, //n/b icon reversed
  { name: "MySQL", icon: mysqlIcon, strength: 75 },
  { name: "Postgre", icon: Images.Postgre, strength: 69 },
  { name: "Prisma ORM", icon: Images.Prisma, strength: 80 },
  { name: "Node.js", icon: nodejsIcon, strength: 83 },
  { name: "Express.js", icon: expressIcon, strength: 80 },
  { name: "JWT", icon: Images.JWT, strength: 83 },
  { name: "Cloudinary", icon: Images.Cloudinary, strength: 80 },
  { name: "Render", iconDark: Images.Render, iconLight: Images.RenderWhite, strength: 85 },
  { name: "Nodemailer", icon: "https://raw.githubusercontent.com/nodemailer/nodemailer/master/assets/nm_logo_200x136.png", strength: 80 },
  { name: "Flutter", icon: flutterIcon, strength: 85 },
  { name: "React", icon: reactIcon, strength: 88 },
  { name: "Next.js", icon: Images.Nextjs, strength: 79 },
  { name: "TypeScript", icon: tsIcon, strength: 92 },
  {
    name: "Jquery",
    iconDark: jqueryDarkIcon,
    iconLight: jqueryLightIcon,
    strength: 90,
  },
  { name: "JavaScript", icon: jsIcon, strength: 95 },
];

const SunContainer = styled.div`
  position: relative;
  margin: 150px;
  width: 250px;
  height: 250px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.skillSetBg};
  transition: background-color 0.3s ease;

  @media (max-width: 576px) {
    width: 180px;
    height: 180px;
  }
`;
const PlanetImgCover = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  border: 1px solid ${({ theme }) => theme.planetBorder};
`;

const PanelContainer = styled.div`
  width: 180px;
  height: 180px;
  @media (max-width: 576px) {
    width: 135px;
    height: 135px;
  }
  border-radius: 50%;
  padding: 20px;
  background-color: transparent;
  border: 1px solid ${({ theme }) => theme.planetBorder};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  z-index: 10;

  .skillTittle {
    font-weight: 600;
    text-align: center;
      @media (max-width: 576px) {
    font-size: 12.5px;
  }
  }
  .strengthBar {
    width: 100%;
    background-color: ${({ theme }) => theme.skillSetBg};
    border-radius: 4px;
    overflow: hidden;
    border: 1px solid ${({ theme }) => theme.planetBorder};
  }
`;

const ProgressBar = styled.div<{ $strength: number }>`
  width: ${({ $strength }) => $strength}%;
  background-color: ${({ theme }) => theme.text};
  transition: width: 0.3s ease;
  font-wight: 600;
  color:  ${({ theme }) => theme.circularIconTextBg};
  font-size: 12px;
  text-align: center;
`;

const SkillDetailPanel: React.FC<SkillDetailProps> = ({
  skillName,
  strength,
  onClose,
}) => {
  return (
    <PanelContainer>
      <div className="skillTittle">{skillName}</div>
      <div className="strengthBar ">
        <ProgressBar $strength={strength}>{strength}%</ProgressBar>
      </div>
      <Circlebtn onClick={onClose} $size="36px">
        <div className="txtPresent">&#10005;</div>
      </Circlebtn>
    </PanelContainer>
  );
};

const SkillsSet: React.FC<IsDarkModeProp> = ({ isDarkMode }) => {
  const sunRef = useRef<HTMLDivElement>(null);
  const isMobileMode = useMediaQuery(577);//to account for 576 dimensions change
  const [planetPositions, setPlanetPositions] = useState<
    { x: number; y: number; skill: any }[]
  >([]);
  const [selectedSkill, setSelectedSkill] = useState<{
    name: string;
    strength: number;
  } | null>(null);

  let CircularBgVal = {
    circleBgSize: isMobileMode ? "145px" : "200px",
    imgHeight: "60px",
    imgWidth: "100px",
  };

  //  Sun and planet logic
  useEffect(() => {
    if (sunRef.current) {
      const sun = sunRef.current;
      const offsetToParentCenter = sun.offsetWidth / 2;
      const offsetToChildCenter = 30; //important, this is half the class App-planet div, ensures proper alignment around the circle
      const totalOffset = offsetToParentCenter - offsetToChildCenter;

      const divAngle = 360 / skills.length;
      const radius = isMobileMode ? 130 : 190;

      //calculte planet positions and atore them in state
      const newPlanetPositions = skills.map((skill, i) => {
        const y =
          Math.sin(divAngle * i * (Math.PI / 180)) * radius + totalOffset;
        const x =
          Math.cos(divAngle * i * (Math.PI / 180)) * radius + totalOffset;
        return { x, y, skill };
      });

      setPlanetPositions(newPlanetPositions);
    }
  }, [isDarkMode, isMobileMode]);

  return (
    <div className="d-flex flex-column justify-content-center align-items-center">
      <span
        style={{ marginBottom: "0.8rem", fontWeight: "200", fontSize: "1rem" }}
      >
        {" "}
        <Name>M</Name>y Skills
      </span>
      <SunContainer
        ref={sunRef}
        className="d-flex justify-content-center align-items-center"
      >
        <CircleBg
          $circleBgSize={CircularBgVal.circleBgSize}
          $circleBgColor={(theme) => theme.body}
        >
          {!selectedSkill && (
            <img
              src={isDarkMode ? SkillsetWhite : SkillsetBlack}
              alt="Skills set"
              style={{
                height: CircularBgVal.imgHeight,
                width: CircularBgVal.imgWidth,
              }}
            />
          )}

          {selectedSkill && (
            <SkillDetailPanel
              skillName={selectedSkill.name}
              strength={selectedSkill.strength}
              onClose={() => setSelectedSkill(null)}
            />
          )}
        </CircleBg>

        {/* Planets rendering */}
        {planetPositions.map(({ x, y, skill }, i) => {
          return (
            <div
              key={i}
              className="App-planet"
              style={{
                position: "absolute",
                top: `${y}px`,
                left: `${x}px`,
              }}
            >
              <GsapMagnetic
                key={i}
                $magneticBorderRadius="50%"
                $magneticOverflow="visible"
                $maxTranslation={10}
              >
             
                <PlanetImgCover
                  onClick={() =>
                    setSelectedSkill({
                      name: skill.name,
                      strength: skill.strength,
                    })
                  }
                >
                  <img
                    className="imgPresent"
                    src={
                      isDarkMode && skill.iconDark
                        ? skill.iconLight
                        : skill.iconDark
                        ? skill.iconDark
                        : skill.icon ?? ""
                    }
                    alt={skill.name}
                    style={{ width: "30px", height: "auto" }}
                  />
                </PlanetImgCover>
              
              </GsapMagnetic>
            </div>
          );
        })}
     
      </SunContainer>
    </div>
   
  );
};

export default React.memo(SkillsSet);
